import script from "./BaseLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLayout.vue?vue&type=style&index=0&id=319dab70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319dab70"]])

export default __exports__